module.exports = __webpack_public_path__ + "static/qr_CheWei.570196ee.png";